import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'orderByNumber'
})
export class OrderByPipeNumber implements PipeTransform {
	transform(value: any[]): any {
		if (value) {
			let str = JSON.stringify(value);
			function compare(a, b) {
				return a - b;
			}

			return value.sort(compare);
		}
	}
}
